/* GANGWANI HOUSE · extras: click or tap the Oneself logo and it gets sliced apart.
   Blades cut through it, the cut edges show red, blood splatters across the face,
   then the head falls apart in pieces and reforms. The logo keeps spinning throughout. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var sid = 0;
  function rnd(a, b) { return a + Math.random() * (b - a); }

  /* split a convex polygon by the line through p with normal n */
  function split(poly, p, n) {
    var A = [], B = [];
    for (var i = 0; i < poly.length; i++) {
      var a = poly[i], b = poly[(i + 1) % poly.length];
      var da = (a[0] - p[0]) * n[0] + (a[1] - p[1]) * n[1];
      var db = (b[0] - p[0]) * n[0] + (b[1] - p[1]) * n[1];
      if (da >= 0) A.push(a);
      if (da <= 0) B.push(a);
      if (da * db < 0) {
        var t = da / (da - db);
        var q = [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
        A.push(q); B.push(q);
      }
    }
    return [A, B];
  }

  /* realistic splatter: small wet core, long thin tendrils and fine spray thrown in one direction */
  function splatter(size, dir) {
    var id = 'gwsp' + (sid++);
    var h = '<defs><filter id="' + id + 'f" x="-30%" y="-30%" width="160%" height="160%"><feTurbulence type="fractalNoise" baseFrequency="' + rnd(.06, .1) + '" numOctaves="3" seed="' + Math.floor(rnd(1, 999)) + '"/><feDisplacementMap in="SourceGraphic" scale="' + (size * .07) + '" xChannelSelector="R" yChannelSelector="G"/></filter>' +
      '<radialGradient id="' + id + 'g" cx=".42" cy=".38" r=".75"><stop offset="0" stop-color="#a0000a"/><stop offset=".55" stop-color="#700005"/><stop offset="1" stop-color="#3a0002"/></radialGradient>' +
      '<radialGradient id="' + id + 'h" cx=".35" cy=".3" r=".5"><stop offset="0" stop-color="#ff8a8f" stop-opacity=".5"/><stop offset="1" stop-color="#ff8a8f" stop-opacity="0"/></radialGradient></defs><g filter="url(#' + id + 'f)" fill="url(#' + id + 'g)">';
    var r = size * .075, k, a, x, y;
    for (k = 0; k < 5; k++) h += '<circle cx="' + rnd(-r * .6, r * .6) + '" cy="' + rnd(-r * .6, r * .6) + '" r="' + rnd(r * .45, r) + '"/>';
    var n = Math.floor(rnd(9, 14));
    for (k = 0; k < n; k++) {
      a = dir + rnd(-1.1, 1.1) + (Math.random() < .15 ? Math.PI : 0);
      var len = rnd(r * 1.6, size * .47), w = rnd(r * .12, r * .32);
      x = Math.cos(a); y = Math.sin(a);
      var px = -y, py = x;
      h += '<path d="M' + (px * w) + ',' + (py * w) + ' Q' + (x * len * .5 + px * w * .45) + ',' + (y * len * .5 + py * w * .45) + ' ' + (x * len) + ',' + (y * len) + ' Q' + (x * len * .5 - px * w * .45) + ',' + (y * len * .5 - py * w * .45) + ' ' + (-px * w) + ',' + (-py * w) + 'Z"/>';
      var bx = x * len, by = y * len, br = w * rnd(.6, 1.2);
      h += '<ellipse cx="' + bx + '" cy="' + by + '" rx="' + (br * 1.6) + '" ry="' + br + '" transform="rotate(' + (a * 180 / Math.PI) + ' ' + bx + ' ' + by + ')"/>';
    }
    var m = Math.floor(rnd(22, 34));
    for (k = 0; k < m; k++) {
      a = dir + rnd(-1.4, 1.4) + (Math.random() < .15 ? Math.PI : 0);
      var d = rnd(size * .15, size * .5);
      x = Math.cos(a) * d; y = Math.sin(a) * d;
      var sr = rnd(.5, 2) * (size / 110);
      h += '<ellipse cx="' + x + '" cy="' + y + '" rx="' + (sr * rnd(1.4, 3.2)) + '" ry="' + sr + '" transform="rotate(' + (a * 180 / Math.PI) + ' ' + x + ' ' + y + ')"/>';
    }
    h += '</g><g filter="url(#' + id + 'f)" fill="url(#' + id + 'h)"><circle cx="' + (-r * .3) + '" cy="' + (-r * .3) + '" r="' + (r * .5) + '"/></g>';
    return { inner: h, size: size };
  }

  /* where the splatter lands: top of the head, both sides, the bottom, and the middle */
  var SPOTS = [[.5, .12], [.16, .42], [.86, .36], [.3, .84], [.74, .8], [.52, .56]];
  /* cuts: center x, center y (0..1), angle, length (share of the diagonal) */
  var CUTS = [[.5, .45, 55, 1], [.52, .5, -52, 1], [.5, .3, 4, .7], [.45, .66, -8, .55], [.62, .78, 30, .4]];

  function setup(spin, srcCanvas, opts) {
    if (!spin || spin.dataset.gwSlice) return;
    spin.dataset.gwSlice = '1';
    var stage = document.createElement('div');
    stage.className = 'gwx-stage';
    stage.setAttribute('aria-hidden', 'true');
    spin.appendChild(stage);
    var busy = false;

    function play(done) {
      var src = srcCanvas();
      if (busy || !src || !src.width) { if (done) done(); return; }
      busy = true;
      var url;
      try { url = src.toDataURL('image/png'); } catch (e) { busy = false; if (done) done(); return; }
      var W = spin.offsetWidth, H = spin.offsetHeight;
      var k = H / 306;
      stage.style.setProperty('--logo', 'url(' + url + ')');
      /* a still copy of the logo, used to paint the blood into the cut faces */
      var snap = document.createElement('canvas');
      snap.width = src.width; snap.height = src.height;
      snap.getContext('2d').drawImage(src, 0, 0);
      stage.innerHTML = '';
      var glass = document.createElement('div');
      glass.className = 'gwx-glass';
      stage.appendChild(glass);
      spin.classList.add('gwx-on');
      var pieces = [{ poly: [[0, 0], [W, 0], [W, H], [0, H]], ox: 0, oy: 0 }];
      var lines = [];
      /* the blood lives on the pieces, so it falls with them */
      var blood = [];
      var sw = Math.max(1.6, 5 * k), sw2 = Math.max(.6, 1.2 * k);

      /* each piece keeps the logo's thickness: a stack of chrome slices front to back,
         so the cut pieces show solid metal edges as the logo turns */
      var D = Math.max(5, 26 * k), K = H > 120 ? 40 : 14;
      /* every depth slice carries the cut lines painted in blood, masked to the logo,
         so the cut faces are red all the way through the thickness, front to back */
      function cutURL() {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var c = document.createElement('canvas');
        c.width = Math.round(W * dpr); c.height = Math.round(H * dpr);
        var x = c.getContext('2d');
        x.scale(dpr, dpr);
        var sc = Math.min(W / snap.width, H / snap.height), iw = snap.width * sc, ih = snap.height * sc;
        x.drawImage(snap, (W - iw) / 2, (H - ih) / 2, iw, ih);
        x.globalCompositeOperation = 'source-atop';
        x.lineCap = 'round';
        [[sw * 2.2, '#7a0006'], [sw * 1.1, '#b8000c'], [sw2, '#ff4a52']].forEach(function (st) {
          x.lineWidth = st[0]; x.strokeStyle = st[1];
          lines.forEach(function (l) { x.beginPath(); x.moveTo(l[0], l[1]); x.lineTo(l[2], l[3]); x.stroke(); });
        });
        try { return c.toDataURL('image/png'); } catch (e) { return ''; }
      }
      function render() {
        var cu = cutURL(); if (cu) stage.style.setProperty('--cut', 'url(' + cu + ')'); else stage.style.removeProperty('--cut');
        [].slice.call(stage.querySelectorAll('.gwx-piece')).forEach(function (e) { e.remove(); });
        pieces.forEach(function (pc) {
          var el = document.createElement('div');
          el.className = 'gwx-piece';
          el.style.transform = 'translate(' + pc.ox + 'px,' + pc.oy + 'px)';
          var clip = 'clip-path:polygon(' + pc.poly.map(function (q) { return q[0].toFixed(1) + 'px ' + q[1].toFixed(1) + 'px'; }).join(',') + ');';
          var html = '';
          for (var j = K - 1; j >= 0; j--) {
            var z = D / 2 - D * j / (K - 1);
            var b = (j === 0 || j === K - 1) ? 1 : .8;
            html += '<div class="gwx-img" style="' + clip + 'transform:translateZ(' + z.toFixed(2) + 'px);filter:brightness(' + b.toFixed(2) + ')"></div>';
          }
          /* only the splatters that actually reach this piece are drawn on it */
          var bx0 = 1e9, by0 = 1e9, bx1 = -1e9, by1 = -1e9;
          pc.poly.forEach(function (q) { bx0 = Math.min(bx0, q[0]); by0 = Math.min(by0, q[1]); bx1 = Math.max(bx1, q[0]); by1 = Math.max(by1, q[1]); });
          var mine = blood.filter(function (b) { var r = b.size / 2; return b.x + r > bx0 && b.x - r < bx1 && b.y + r > by0 && b.y - r < by1; });
          /* the blood shows on the front face and soaks through to the reverse side */
          var secIn = lines.map(function (l) {
            return '<line x1="' + l[0] + '" y1="' + l[1] + '" x2="' + l[2] + '" y2="' + l[3] + '" stroke="#c0000c" stroke-width="' + sw + '"/><line x1="' + l[0] + '" y1="' + l[1] + '" x2="' + l[2] + '" y2="' + l[3] + '" stroke="#ff5a60" stroke-width="' + sw2 + '"/>';
          }).join('');
          [1, -1].forEach(function (side) {
            if (mine.length) {
              html += '<div class="gwx-blood" style="' + clip + 'transform:translateZ(' + (side * (D / 2 + .4)).toFixed(2) + 'px)">' + mine.map(function (b) {
                var s = b.size;
                return '<svg class="gwx-splat' + (b.fresh ? '' : ' gwx-set') + '" width="' + s + '" height="' + s + '" viewBox="' + (-s / 2) + ' ' + (-s / 2) + ' ' + s + ' ' + s + '" style="left:' + b.x + 'px;top:' + b.y + 'px">' + b.inner + '</svg>';
              }).join('') + '</div>';
            }
            html += '<svg class="gwx-sec" width="' + W + '" height="' + H + '" style="' + clip + 'transform:translateZ(' + (side * (D / 2 + .2)).toFixed(2) + 'px)">' + secIn + '</svg>';
          });
          el.innerHTML = html;
          pc.el = el;
          stage.insertBefore(el, glass);
        });
        blood.forEach(function (b) { b.fresh = false; });
      }
      render();

      var spots = SPOTS.slice().sort(function () { return Math.random() - .5; });
      CUTS.forEach(function (c, i) {
        setTimeout(function () {
          var a = c[2] * Math.PI / 180, dx = Math.cos(a), dy = Math.sin(a);
          var cx = c[0] * W, cy = c[1] * H, L = Math.sqrt(W * W + H * H) * c[3];
          var p = [cx, cy], n = [-dy, dx];
          var x0 = cx - dx * L / 2, y0 = cy - dy * L / 2, x1 = cx + dx * L / 2, y1 = cy + dy * L / 2;
          var bl = document.createElement('i');
          bl.className = 'gwx-blade';
          bl.style.left = x0 + 'px'; bl.style.top = y0 + 'px'; bl.style.width = L + 'px';
          bl.style.setProperty('--a', c[2] + 'deg');
          stage.appendChild(bl);
          setTimeout(function () {
            var gap = (c[3] > .6 ? 2.2 : 1.4) * Math.max(k, .4);
            var np = [];
            pieces.forEach(function (pc) {
              var cxp = 0, cyp = 0;
              pc.poly.forEach(function (q) { cxp += q[0]; cyp += q[1]; });
              cxp /= pc.poly.length; cyp /= pc.poly.length;
              /* a shorter cut only splits the pieces it actually reaches */
              if (Math.abs((cxp - cx) * dx + (cyp - cy) * dy) > L / 2 + 20 * k) { np.push(pc); return; }
              var s = split(pc.poly, p, n);
              if (s[0].length > 2 && s[1].length > 2) {
                np.push({ poly: s[0], ox: pc.ox + n[0] * gap, oy: pc.oy + n[1] * gap });
                np.push({ poly: s[1], ox: pc.ox - n[0] * gap, oy: pc.oy - n[1] * gap });
              } else np.push(pc);
            });
            pieces = np;
            lines.push([x0, y0, x1, y1]);
            var put = function (sp, sz) {
              var sx = sp[0] * W + rnd(-10, 10) * k, sy = sp[1] * H + rnd(-10, 10) * k;
              var s2 = splatter(sz, Math.atan2(sy - H * .5, sx - W * .5));
              blood.push({ inner: s2.inner, size: s2.size, x: sx, y: sy, fresh: true });
            };
            put(spots[i % spots.length], rnd(80, 115) * k);
            if (i === 1) put(spots[5], rnd(70, 95) * k);
            render();
          }, 110);
        }, 120 + i * 220);
      });

      /* the head falls apart */
      setTimeout(function () {
        pieces.forEach(function (pc) {
          var cxp = 0, cyp = 0;
          pc.poly.forEach(function (q) { cxp += q[0]; cyp += q[1]; });
          cxp /= pc.poly.length; cyp /= pc.poly.length;
          var el = pc.el;
          setTimeout(function () {
            el.classList.add('fall');
            el.style.setProperty('--ft', rnd(.9, 1.3) + 's');
            el.style.transform = 'translate(' + (pc.ox + (cxp - W / 2) * rnd(.3, .8)) + 'px,' + (pc.oy + H * rnd(1.2, 1.7)) + 'px) rotate(' + rnd(-55, 55) + 'deg)';
          }, (1 - cyp / H) * 120 + rnd(0, 140));
        });
      }, 1750);
      /* the logo reforms and carries on spinning */
      setTimeout(function () {
        spin.classList.remove('gwx-on');
        setTimeout(function () { stage.innerHTML = ''; busy = false; if (done) done(); }, 550);
      }, 3500);
    }

    spin.addEventListener('click', function (e) {
      if (opts && opts.link) {
        /* the top bar logo is a link home: play the slice first, then go */
        var href = spin.getAttribute('href');
        var here = href && (location.pathname === href || location.pathname === href + '/');
        if (busy) { e.preventDefault(); return; }
        e.preventDefault();
        play();
        /* the whole page you are looking at gets slashed apart and falls, then home opens (on home too) */
        if (href) pageSlash(function () {
          try { sessionStorage.setItem('gwSlash', '1'); } catch (er) {}
          location.href = href;
        });
        bloodSpray(!href);
        return;
      }
      play();
    });
  }


  /* page slash: the screen is cut by the same blades as the logo, at the same moments and angles,
     the cuts bleed, and the page and the logo fall apart in pieces together before home opens.
     Each page piece is a copy of what is on screen, clipped to its shape. */
  function pageSlash(done) {
    var W = innerWidth, H = innerHeight, sy = scrollY, k = Math.min(W, H) / 700;
    /* the live logo stays exactly where it is: the header is raised above the cut page with everything
       in it hidden except the logo, so the logo's own slice plays in place, in unison with the page */
    var lift = null;
    if (!document.getElementById('gwz-style')) {
      var zs = document.createElement('style');
      zs.id = 'gwz-style';
      zs.textContent = 'body.gw .gwz-lift{z-index:2147482001 !important;background:transparent !important}' +
        'body.gw .gwz-lift *{visibility:hidden !important;background-color:transparent !important;-webkit-backdrop-filter:none !important;backdrop-filter:none !important;box-shadow:none !important;border-color:transparent !important}' +
        'body.gw .gwz-lift .header__heading-link,body.gw .gwz-lift .header__heading-link *{visibility:visible !important}' +
        '.gwz-page,.gwz-page *{animation:none !important;transition:none !important}' +
        '.gwz-page .scroll-trigger{opacity:1 !important;transform:none !important}' +
        '@keyframes gwz-drip{to{stroke-dashoffset:0}}';
      document.head.appendChild(zs);
    }
    var host = document.createElement('div');
    host.setAttribute('aria-hidden', 'true');
    host.style.cssText = 'position:fixed;inset:0;z-index:2147482000;overflow:hidden;background:#000;pointer-events:auto;';
    var sticky = document.querySelector('.section-header');
    if (sticky) sticky.dataset.gwSt = sticky.getBoundingClientRect().top.toFixed(1);
    var bs = getComputedStyle(document.body);
    /* copy canvases too, since a copied canvas comes out blank */
    function copyCanvases(fromList, to) {
      var tc = to.querySelectorAll('canvas');
      for (var i = 0; i < tc.length && i < fromList.length; i++) {
        var a = fromList[i], b = tc[i];
        if (!a.width || !a.height) continue;
        b.width = a.width; b.height = a.height;
        try { b.getContext('2d').drawImage(a, 0, 0); } catch (e) {}
      }
    }
    /* anything off screen inside the copy is emptied out, keeping only its box, so every page piece stays light */
    /* theme components (gallery, share button, dropdowns) would start up again inside every copy and throw errors,
       so in the copies they become plain boxes that look the same */
    function plain(l, c) {
      if (c.tagName.indexOf('-') < 0) return c;
      var d = document.createElement('div');
      for (var ai = 0; ai < c.attributes.length; ai++) { var at = c.attributes[ai]; try { d.setAttribute(at.name, at.value); } catch (e) {} }
      d.style.display = getComputedStyle(l).display;
      while (c.firstChild) d.appendChild(c.firstChild);
      c.replaceWith(d);
      return d;
    }
    function prune(live, copy) {
      var lc = live.children, cc = copy.children;
      for (var i = lc.length - 1; i >= 0; i--) {
        var l = lc[i], c = cc[i];
        if (!c || c.tagName !== l.tagName) continue;
        c = plain(l, c);
        var r = l.getBoundingClientRect();
        if (!r.width && !r.height) {
          /* hidden things like the closed menu drawer are emptied too */
          if (getComputedStyle(l).display === 'none') c.innerHTML = '';
          continue;
        }
        if (r.bottom < -40 || r.top > H + 40 || r.right < -40 || r.left > W + 40) {
          var ps = getComputedStyle(l).position;
          if (ps === 'fixed' || ps === 'sticky') continue;
          c.innerHTML = ''; c.style.visibility = 'hidden';
          c.style.width = r.width + 'px'; c.style.height = r.height + 'px'; c.style.boxSizing = 'border-box';
        } else if (l.children.length) prune(l, c);
      }
    }
    function firstPage() {
      var wrap = document.createElement('div');
      wrap.style.cssText = 'position:absolute;left:0;top:' + (-sy) + 'px;width:' + document.body.clientWidth + 'px;';
      wrap.className = 'gwz-page';
      var canv = [], live = document.querySelectorAll('canvas');
      for (var ci = 0; ci < live.length; ci++) live[ci].setAttribute('data-gwc', ci);
      [].forEach.call(document.body.children, function (ch) {
        if (ch === host || /^(SCRIPT|IFRAME|NOSCRIPT|TEMPLATE|LINK)$/.test(ch.tagName) || ch.classList.contains('gw-storm') || ch.id === 'PBarNextFrameWrapper' || ch.id === 'web-pixels-manager-sandbox-container') return;
        var r0 = ch.getBoundingClientRect();
        if (r0.height && (r0.bottom < 0 || r0.top > H) && getComputedStyle(ch).position !== 'fixed') { var ph = document.createElement('div'); ph.style.height = r0.height + 'px'; wrap.appendChild(ph); return; }
        var cl = ch.cloneNode(true);
        /* sections off screen are left out of the copy, only their space is kept */
        var ls = ch.querySelectorAll('.shopify-section'), cs = cl.querySelectorAll('.shopify-section');
        for (var si = 0; si < ls.length && si < cs.length; si++) {
          var r = ls[si].getBoundingClientRect();
          if (r.height && (r.bottom < -40 || r.top > H + 40) && !ls[si].contains(document.querySelector('.header__heading-link'))) {
            var sp = document.createElement('div'); sp.style.height = r.height + 'px'; cs[si].replaceWith(sp);
          } else canv = canv.concat([].slice.call(ls[si].querySelectorAll('canvas')));
        }
        if (!ls.length) canv = canv.concat([].slice.call(ch.querySelectorAll('canvas')));
        prune(ch, cl);
        cl = plain(ch, cl);
        wrap.appendChild(cl);
      });
      [].forEach.call(wrap.querySelectorAll('script, iframe, video, noscript'), function (n) { n.remove(); });
      /* the logo in the copies stays hidden (the real one plays on top), so its canvases are not copied at all */
      [].forEach.call(wrap.querySelectorAll('.header__heading-link'), function (h) { h.innerHTML = ''; });
      /* each copied canvas is matched to its live one by id */
      [].forEach.call(wrap.querySelectorAll('canvas[data-gwc]'), function (b) {
        var a = live[+b.getAttribute('data-gwc')];
        if (!a || !a.width || !a.height) return;
        b.width = a.width; b.height = a.height;
        try { b.getContext('2d').drawImage(a, 0, 0); } catch (e) {}
      });
      var st = wrap.querySelector('[data-gw-st]');
      if (st) { st.style.position = 'absolute'; st.style.top = (sy + parseFloat(st.dataset.gwSt)) + 'px'; st.style.left = '0'; st.style.right = '0'; st.style.zIndex = '4'; }
      return wrap;
    }
    function newPiece(wrap) {
      var el = document.createElement('div');
      el.style.cssText = 'position:absolute;inset:0;overflow:hidden;contain:strict;will-change:transform;transition:transform .14s ease-out;' +
        'background-color:' + bs.backgroundColor + ';background-image:' + bs.backgroundImage + ';background-size:' + bs.backgroundSize + ';background-repeat:' + bs.backgroundRepeat + ';background-position:center ' + (-sy) + 'px;';
      el.appendChild(wrap);
      var cuts = document.createElementNS(NS, 'svg');
      cuts.setAttribute('width', W); cuts.setAttribute('height', H);
      cuts.style.cssText = 'position:absolute;left:0;top:0;overflow:visible;pointer-events:none;';
      el.appendChild(cuts);
      host.appendChild(el);
      return el;
    }
    var w0 = firstPage();
    if (sticky) delete sticky.dataset.gwSt;
    /* in the page copies the logo is left out, since the real one plays on top in the same spot */
    [].forEach.call(w0.querySelectorAll('.header__heading-link'), function (h) { h.style.visibility = 'hidden'; });
    if (sticky) { sticky.classList.add('gwz-lift'); lift = sticky; }
    var pieces = [{ poly: [[0, 0], [W, 0], [W, H], [0, H]], ox: 0, oy: 0, el: newPiece(w0) }];
    document.body.appendChild(host);
    var lines = [], splats = [], drips = [];
    function clipOf(pc) { return 'polygon(' + pc.poly.map(function (q) { return q[0].toFixed(1) + 'px ' + q[1].toFixed(1) + 'px'; }).join(',') + ')'; }
    function paint() {
      var svg = lines.map(function (l) {
        return '<line x1="' + l[0] + '" y1="' + l[1] + '" x2="' + l[2] + '" y2="' + l[3] + '" stroke="#7a0006" stroke-width="' + (14 * k + 4) + '" stroke-linecap="round"/>' +
          '<line x1="' + l[0] + '" y1="' + l[1] + '" x2="' + l[2] + '" y2="' + l[3] + '" stroke="#c0000c" stroke-width="' + (7 * k + 2) + '" stroke-linecap="round"/>' +
          '<line x1="' + l[0] + '" y1="' + l[1] + '" x2="' + l[2] + '" y2="' + l[3] + '" stroke="#ff5a60" stroke-width="' + (1.6 * k + 1) + '" stroke-linecap="round"/>';
      }).join('') + drips.map(function (d) {
        /* blood running down out of the cut: it keeps growing across repaints by starting partway in */
        var el = Math.max(0, (performance.now() - d.t0) / 1000).toFixed(3);
        return '<line x1="' + d.x + '" y1="' + d.y + '" x2="' + d.x + '" y2="' + (+d.y + d.len).toFixed(1) + '" stroke="' + d.c + '" stroke-width="' + d.w + '" stroke-linecap="round" stroke-dasharray="' + d.len + ' ' + d.len + '" stroke-dashoffset="' + d.len + '" style="animation:gwz-drip ' + d.dur + 's cubic-bezier(.35,0,.75,.6) -' + el + 's forwards"/>';
      }).join('') + splats.map(function (b) {
        return '<svg x="' + (b.x - b.size / 2) + '" y="' + (b.y - b.size / 2) + '" width="' + b.size + '" height="' + b.size + '" viewBox="' + (-b.size / 2) + ' ' + (-b.size / 2) + ' ' + b.size + ' ' + b.size + '" overflow="visible" opacity=".92">' + b.inner + '</svg>';
      }).join('');
      pieces.forEach(function (pc) {
        pc.el.style.clipPath = clipOf(pc);
        pc.el.style.transform = 'translate(' + pc.ox + 'px,' + pc.oy + 'px)';
        pc.el.lastChild.innerHTML = svg;
      });
    }
    paint();
    /* the same five slashes as the logo, at the same moments: blade at 120 + 220 per cut, split 110 later */
    CUTS.forEach(function (c, i) {
      setTimeout(function () {
        var a = c[2] * Math.PI / 180, dx = Math.cos(a), dy = Math.sin(a), L = Math.hypot(W, H) * (c[3] > .6 ? 1.2 : c[3] + .25);
        var cx = c[0] * W, cy = c[1] * H, n = [-dy, dx];
        var x0 = cx - dx * L / 2, y0 = cy - dy * L / 2, x1 = cx + dx * L / 2, y1 = cy + dy * L / 2;
        var bl = document.createElement('i');
        bl.style.cssText = 'position:absolute;z-index:9;left:' + x0 + 'px;top:' + y0 + 'px;width:' + L + 'px;height:3px;transform-origin:0 50%;background:linear-gradient(90deg,rgba(255,255,255,0),#fff 40%,#fff 60%,rgba(255,255,255,0));box-shadow:0 0 14px rgba(255,255,255,.9);';
        host.appendChild(bl);
        bl.animate([{ transform: 'translateY(-50%) rotate(' + c[2] + 'deg) scaleX(0)', opacity: 1 }, { transform: 'translateY(-50%) rotate(' + c[2] + 'deg) scaleX(1)', opacity: 1, offset: .6 }, { transform: 'translateY(-50%) rotate(' + c[2] + 'deg) scaleX(1)', opacity: 0 }], { duration: 220, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' });
        setTimeout(function () {
          bl.remove();
          var gap = (c[3] > .6 ? 7 : 4.5) * Math.max(k, .6), np = [];
          pieces.forEach(function (pc) {
            var cxp = 0, cyp = 0;
            pc.poly.forEach(function (q) { cxp += q[0]; cyp += q[1]; });
            cxp /= pc.poly.length; cyp /= pc.poly.length;
            /* a shorter cut only splits the pieces it actually reaches */
            if (Math.abs((cxp - cx) * dx + (cyp - cy) * dy) > L / 2 + 30 * k) { np.push(pc); return; }
            var s = split(pc.poly, [cx, cy], n);
            if (s[0].length > 2 && s[1].length > 2) {
              var src = pc.el.querySelectorAll('canvas'), el2 = pc.el.cloneNode(true);
              copyCanvases(src, el2);
              host.appendChild(el2);
              np.push({ poly: s[0], ox: pc.ox + n[0] * gap, oy: pc.oy + n[1] * gap, el: pc.el });
              np.push({ poly: s[1], ox: pc.ox - n[0] * gap, oy: pc.oy - n[1] * gap, el: el2 });
            } else np.push(pc);
          });
          pieces = np;
          lines.push([x0, y0, x1, y1]);
          /* blood starts dripping out along the fresh cut */
          var nd = c[3] > .6 ? 8 : 4;
          for (var di = 0; di < nd; di++) {
            var tt = rnd(.08, .92), dxp = x0 + (x1 - x0) * tt, dyp = y0 + (y1 - y0) * tt;
            if (dxp < 4 || dxp > W - 4 || dyp < 0 || dyp > H - 10) continue;
            drips.push({ x: dxp.toFixed(1), y: dyp.toFixed(1), len: Math.round(rnd(45, 150) * Math.max(k, .75)), w: (rnd(2.4, 5) * Math.max(k, .7)).toFixed(1), c: Math.random() < .5 ? '#8e0309' : '#b0000b', dur: rnd(1.1, 1.9).toFixed(2), t0: performance.now() });
          }
          paint();
        }, 110);
      }, 120 + i * 220);
    });
    /* the page falls apart */
    setTimeout(function () {
      pieces.forEach(function (pc) {
        var cxp = 0, cyp = 0;
        pc.poly.forEach(function (q) { cxp += q[0]; cyp += q[1]; });
        cxp /= pc.poly.length; cyp /= pc.poly.length;
        setTimeout(function () {
          pc.el.style.transition = 'transform ' + rnd(.85, 1.1).toFixed(2) + 's cubic-bezier(.45,0,.9,.6)';
          pc.el.style.transform = 'translate(' + (pc.ox + (cxp - W / 2) * rnd(.3, .7)) + 'px,' + (pc.oy + H * rnd(1.15, 1.5)) + 'px) rotate(' + rnd(-28, 28) + 'deg)';
        }, (1 - cyp / H) * 120 + rnd(0, 140));
      });
    }, 1750);
    /* once every piece of the page and the logo has fallen, the logo goes back in its place and home opens */
    setTimeout(function () {
      if (lift) lift.classList.remove('gwz-lift');
      if (done) done();
    }, 3000);
  }

  /* blood through the screen: jets spray out of every cut on a layer above everything, the logo included,
     and the heavy drops hit the screen like glass and splat there, then run */
  function bloodSpray(fade) {
    var W = innerWidth, H = innerHeight, k = Math.max(Math.min(W, H) / 700, .7);
    function R(a, b) { return a + Math.random() * (b - a); }
    function sz() { var u = Math.random(); return u < .7 ? R(.5, 1.6) : u < .93 ? R(1.6, 3.2) : R(3.2, 5.5); }
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5), wrap = document.createElement('div');
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText = 'position:fixed;inset:0;z-index:2147482600;pointer-events:none;transition:opacity .8s ease;';
    function mk() { var c = document.createElement('canvas'); c.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;'; c.width = Math.round(W * dpr); c.height = Math.round(H * dpr); var x = c.getContext('2d'); x.setTransform(dpr, 0, 0, dpr, 0, 0); wrap.appendChild(c); return x; }
    var sx = mk(), dx2 = mk();
    document.body.appendChild(wrap);
    var P = [], emit = [], t0 = performance.now(), last = t0;
    CUTS.forEach(function (c, i) {
      var at = 230 + i * 220, a = c[2] * Math.PI / 180, dx = Math.cos(a), dy = Math.sin(a), L = Math.hypot(W, H) * (c[3] > .6 ? 1.2 : c[3] + .25), cx = c[0] * W, cy = c[1] * H, n = [-dy, dx];
      var cnt = c[3] > .6 ? 4 : 2;
      for (var e = 0; e < cnt; e++) {
        var p = [cx, cy];
        for (var g = 0; g < 30; g++) { var t = R(-.45, .45) * L, x = cx + dx * t, y = cy + dy * t; if (x > 12 && x < W - 12 && y > 12 && y < H - 12) { p = [x, y]; break; } }
        var s = Math.random() < .5 ? 1 : -1;
        emit.push({ x: p[0], y: p[1], nx: n[0] * s, ny: n[1] * s, start: at + R(0, 90), dur: R(300, 520) });
      }
    });
    function stain(x, y, r) {
      sx.fillStyle = 'rgba(92,0,4,.93)';
      sx.beginPath(); sx.arc(x, y, r, 0, 7); sx.fill();
      var j, an, d;
      for (j = 0; j < 5; j++) { an = R(0, 6.3); d = r * R(.3, .8); sx.beginPath(); sx.arc(x + Math.cos(an) * d, y + Math.sin(an) * d, r * R(.4, .75), 0, 7); sx.fill(); }
      for (j = 0; j < 10; j++) { an = R(0, 6.3); d = r * R(1.3, 2.6); sx.beginPath(); sx.arc(x + Math.cos(an) * d, y + Math.sin(an) * d, r * R(.06, .2), 0, 7); sx.fill(); }
      sx.fillStyle = 'rgba(150,0,10,.6)'; sx.beginPath(); sx.arc(x - r * .15, y - r * .15, r * .55, 0, 7); sx.fill();
      if (Math.random() < .7) { sx.strokeStyle = 'rgba(92,0,4,.93)'; sx.lineCap = 'round'; sx.lineWidth = r * R(.25, .45); sx.beginPath(); sx.moveTo(x, y); sx.lineTo(x + R(-1.5, 1.5), y + r * R(1.8, 5)); sx.stroke(); }
    }
    (function frame(now) {
      var t = now - t0, dt = Math.min(.033, (now - last) / 1000); last = now;
      emit.forEach(function (e) {
        if (t < e.start || t > e.start + e.dur) return;
        for (var j = 0; j < 9 && P.length < 650; j++) {
          var an = Math.atan2(e.ny, e.nx) + R(-.38, .38), sp = R(400, 1150) * k, r = sz();
          P.push({ x: e.x + R(-2, 2), y: e.y + R(-2, 2), vx: Math.cos(an) * sp, vy: Math.sin(an) * sp - 250 * k, r: r * k, glass: (r > 2.2 && Math.random() < .22) ? R(.15, .5) : 0, age: 0 });
        }
      });
      P = P.filter(function (p) {
        p.age += dt; p.vy += 2000 * k * dt; p.vx *= .994; p.x += p.vx * dt; p.y += p.vy * dt;
        if (p.glass && p.age > p.glass) { stain(p.x, p.y, p.r * R(2.4, 4)); return false; }
        return !(p.y > H + 30 || p.x < -30 || p.x > W + 30);
      });
      dx2.clearRect(0, 0, W, H); dx2.lineCap = 'round';
      /* drops are grouped by size so each frame is only a handful of strokes */
      var BW = [1.2, 2.2, 3.4, 5, 8], bins = [[], [], [], [], []];
      P.forEach(function (p) { var r = p.r, b = r < 1.2 ? 0 : r < 2.2 ? 1 : r < 3.4 ? 2 : r < 5 ? 3 : 4; bins[b].push(p); });
      bins.forEach(function (list, b) {
        if (!list.length) return;
        dx2.strokeStyle = 'rgba(84,0,4,.95)'; dx2.lineWidth = BW[b] * 1.7; dx2.beginPath();
        list.forEach(function (p) { dx2.moveTo(p.x - p.vx * .011, p.y - p.vy * .011); dx2.lineTo(p.x, p.y); });
        dx2.stroke();
        if (b > 0) {
          dx2.strokeStyle = 'rgba(170,0,12,.9)'; dx2.lineWidth = BW[b] * .9; dx2.beginPath();
          list.forEach(function (p) { dx2.moveTo(p.x - p.vx * .0066, p.y - p.vy * .0066); dx2.lineTo(p.x, p.y); });
          dx2.stroke();
        }
      });
      if (t < 3300) requestAnimationFrame(frame);
      else if (fade) { wrap.style.opacity = '0'; setTimeout(function () { wrap.remove(); }, 900); }
    })(t0);
  }

  /* solid chrome thickness: when the spinning logo turns side on, its edge should read as solid
     polished metal, not see through. Every depth slice is made fully opaque in one even chrome
     tone, and two extra slices fill each gap between the existing ones so the edge has no lines. */
  function chromeShade() { return '.96'; }
  function solidify(m, getSrc, tries) {
    if (!m || m.dataset.gwSolid) return;
    var layers = [].slice.call(m.querySelectorAll('.gw-holo-layer'));
    var src = getSrc();
    if (!layers.length || !src) { if ((tries || 0) < 40) setTimeout(function () { solidify(m, getSrc, (tries || 0) + 1); }, 250); return; }
    m.dataset.gwSolid = '1';
    var N = layers.length;
    var zOf = function (c) { return parseFloat((c.style.transform || '').split('translateZ(')[1]) || 0; };
    layers.forEach(function (c, i) {
      c.style.opacity = '1';
      if (i < N - 1) c.dataset.shade = chromeShade();
    });
    var extras = [];
    for (var i = 0; i < N - 1; i++) {
      for (var f = 1; f <= 2; f++) {
        var c = document.createElement('canvas');
        c.className = 'gw-holo-layer gw-holo-fill';
        c.setAttribute('aria-hidden', 'true');
        var za = zOf(layers[i]), zb = zOf(layers[i + 1]);
        c.style.transform = 'translateZ(' + (za + (zb - za) * f / 3).toFixed(2) + 'px)';
        c.style.opacity = '1';
        c.dataset.shade = chromeShade();
        m.insertBefore(c, layers[i + 1]);
        extras.push(c);
      }
    }
    var tick = 0;
    function frame() {
      /* the filler slices only show at the edge, so they refresh every few frames */
      if (!document.hidden && src.width && (tick++ % 3 === 0 || !extras[0].width)) {
        extras.forEach(function (c) {
          if (c.width !== src.width || c.height !== src.height) { c.width = src.width; c.height = src.height; }
          var x = c.getContext('2d');
          x.clearRect(0, 0, c.width, c.height);
          x.globalCompositeOperation = 'source-over';
          x.drawImage(src, 0, 0);
          var k = parseFloat(c.dataset.shade);
          x.globalCompositeOperation = 'source-atop';
          x.fillStyle = 'rgba(0,0,0,' + (1 - k).toFixed(3) + ')';
          x.fillRect(0, 0, c.width, c.height);
        });
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* side profile: a flat stack of slices goes thin and broken when seen exactly edge on,
     so a solid chrome side wall turns in as the logo reaches side on, front to back the full depth */
  function sideWall(m, spinEl, getSrc, tries) {
    if (!m || m.dataset.gwSide) return;
    var src = getSrc();
    var layers = [].slice.call(m.querySelectorAll('.gw-holo-layer'));
    if (!src || !src.width || !layers.length) { if ((tries || 0) < 40) setTimeout(function () { sideWall(m, spinEl, getSrc, (tries || 0) + 1); }, 300); return; }
    m.dataset.gwSide = '1';
    var zs = layers.map(function (c) { return parseFloat((c.style.transform || '').split('translateZ(')[1]) || 0; });
    zs.push(0);
    var z0 = Math.min.apply(null, zs), z1 = Math.max.apply(null, zs), D = Math.max(2, z1 - z0), zc = (z0 + z1) / 2;
    var wall = document.createElement('canvas');
    wall.className = 'gw-side';
    wall.setAttribute('aria-hidden', 'true');
    m.appendChild(wall);
    function draw() {
      var H = m.offsetHeight, Wd = m.offsetWidth;
      if (!H || !src.width) return;
      wall.style.width = D + 'px';
      wall.style.left = ((Wd - D) / 2) + 'px';
      wall.style.transform = 'translateZ(' + zc.toFixed(2) + 'px) rotateY(90deg)';
      var sh = Math.min(src.height, 600), cw = 8;
      wall.width = cw; wall.height = sh;
      /* which rows of the logo have metal in them: from the side, those rows read as solid */
      var probe = document.createElement('canvas');
      probe.width = 96; probe.height = sh;
      var px = probe.getContext('2d');
      px.drawImage(src, 0, 0, 96, sh);
      var d = px.getImageData(0, 0, 96, sh).data;
      var x = wall.getContext('2d');
      x.clearRect(0, 0, cw, sh);
      x.fillStyle = '#fff';
      for (var y = 0; y < sh; y++) {
        for (var i = 0; i < 96; i++) { if (d[(y * 96 + i) * 4 + 3] > 60) { x.fillRect(0, y, cw, 1); break; } }
      }
      x.globalCompositeOperation = 'source-in';
      var g = x.createLinearGradient(0, 0, 0, sh);
      (window.GW_CHROME || [[0, '#ffffff'], [.5, '#d8dde2'], [1, '#ffffff']]).forEach(function (st) { g.addColorStop(st[0], st[1]); });
      x.fillStyle = g;
      x.fillRect(0, 0, cw, sh);
      x.globalCompositeOperation = 'source-over';
    }
    draw();
    setTimeout(draw, 1500);
    window.addEventListener('resize', draw);
    var anim = null;
    function frame() {
      if (!anim || anim.playState === 'idle') anim = (spinEl.getAnimations ? spinEl.getAnimations() : []).filter(function (a) { return a.animationName === 'gw-holo-spin'; })[0] || null;
      var o = 0;
      if (anim && anim.currentTime != null) {
        var dur = (anim.effect && anim.effect.getComputedTiming().duration) || 9000;
        var ang = (anim.currentTime % dur) / dur * Math.PI * 2;
        var c = Math.abs(Math.cos(ang));
        o = c < .22 ? Math.min(1, (.22 - c) / .1) : 0;
      }
      if (spinEl.classList.contains('gwx-on')) o = 0;
      wall.style.setProperty('--gwo', o.toFixed(3));
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* every spinning Oneself logo turns at the same speed and in unison:
     all spins share one clock, so they face the same way at the same moment */
  function syncSpin() {
    if (!document.getAnimations) return;
    document.getAnimations().forEach(function (a) {
      var n = a.animationName;
      if ((n === 'gw-holo-spin' || n === 'gw-holo-base') && a.startTime !== 0 && a.playState !== 'idle') {
        try { a.startTime = 0; } catch (e) {}
      }
    });
  }
  if (!window.gwSpinSync) {
    window.gwSpinSync = 1;
    syncSpin();
    window.addEventListener('load', syncSpin);
    setInterval(syncSpin, 1500);
  }

  /* page change: mirror chrome lightning fires from both top corners and crosses the screen,
     then the next page opens out of the last flash */
  var bolt = { c: null, x: null, busy: false };
  function boltCanvas() {
    if (bolt.c) return bolt.c;
    var c = document.createElement('canvas');
    c.className = 'gw-storm';
    c.setAttribute('aria-hidden', 'true');
    document.body.appendChild(c);
    bolt.c = c; bolt.x = c.getContext('2d');
    return c;
  }
  function sizeStorm() {
    var c = boltCanvas(), dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width = Math.round(innerWidth * dpr); c.height = Math.round(innerHeight * dpr);
    bolt.x.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  /* jagged channel by midpoint displacement, pushed sideways to the direction of travel */
  function jag(a, b, rough) {
    var pts = [a, b];
    for (var lv = 0; lv < 6; lv++) {
      var np = [pts[0]];
      for (var i = 0; i < pts.length - 1; i++) {
        var p = pts[i], q = pts[i + 1], dx = q[0] - p[0], dy = q[1] - p[1], L = Math.hypot(dx, dy) || 1;
        var off = (Math.random() - .5) * L * rough;
        np.push([(p[0] + q[0]) / 2 - dy / L * off, (p[1] + q[1]) / 2 + dx / L * off], q);
      }
      pts = np;
    }
    return pts;
  }
  /* a bolt with forks that peel off at an angle and fork again */
  function boltFrom(a, b, w, depth, out) {
    var pts = jag(a, b, .32);
    out.push({ pts: pts, w: w });
    if (depth > 2) return out;
    var dx = b[0] - a[0], dy = b[1] - a[1], base = Math.atan2(dy, dx), L = Math.hypot(dx, dy);
    for (var i = 4; i < pts.length - 6; i += 3) {
      if (Math.random() < .2 / (depth + 1)) {
        var ang = base + (Math.random() < .5 ? -1 : 1) * (.35 + Math.random() * .6);
        var len = L * (.22 + Math.random() * .35) * (1 - i / pts.length * .5), p = pts[i];
        boltFrom(p, [p[0] + Math.cos(ang) * len, p[1] + Math.sin(ang) * len], w * .55, depth + 1, out);
      }
    }
    return out;
  }
  /* crossfire: one bolt from each top corner, fired diagonally across the screen so they cross */
  function crossfire() {
    var W = innerWidth, H = innerHeight;
    return [boltFrom([-6, -6], [W * (.62 + Math.random() * .3), H * (.72 + Math.random() * .3)], 3.4, 0, []),
            boltFrom([W + 6, -6], [W * (.08 + Math.random() * .3), H * (.72 + Math.random() * .3)], 3.4, 0, [])];
  }
  /* the bolts are mirror chrome like the logo: soft white glow, chrome body, white hot core */
  function drawStorm(bolts, flash, dim) {
    var x = bolt.x, W = innerWidth, H = innerHeight;
    x.clearRect(0, 0, W, H);
    if (dim > 0) { x.fillStyle = 'rgba(3,3,4,' + dim + ')'; x.fillRect(0, 0, W, H); }
    if (flash > 0) {
      [[0, 0], [W, 0]].forEach(function (c) {
        var g = x.createRadialGradient(c[0], c[1], 0, c[0], c[1], Math.max(W, H) * .9);
        g.addColorStop(0, 'rgba(255,255,255,' + flash + ')');
        g.addColorStop(.35, 'rgba(205,212,220,' + flash * .35 + ')');
        g.addColorStop(1, 'rgba(120,128,138,0)');
        x.fillStyle = g; x.fillRect(0, 0, W, H);
      });
    }
    var cs = x.createLinearGradient(0, 0, W * .3, H);
    (window.GW_CHROME || [[0, '#ffffff'], [.5, '#a9b1ba'], [1, '#ffffff']]).forEach(function (st) { cs.addColorStop(st[0], st[1]); });
    x.lineJoin = 'round'; x.lineCap = 'round';
    bolts.forEach(function (b) {
      if (b.a <= 0) return;
      x.globalAlpha = b.a;
      b.segs.forEach(function (sg) {
        x.beginPath();
        sg.pts.forEach(function (p, i) { if (i) x.lineTo(p[0], p[1]); else x.moveTo(p[0], p[1]); });
        x.shadowColor = 'rgba(255,255,255,.9)'; x.shadowBlur = 22;
        x.strokeStyle = 'rgba(214,220,228,.45)'; x.lineWidth = sg.w * 3.4; x.stroke();
        x.shadowBlur = 6;
        x.strokeStyle = cs; x.lineWidth = sg.w * 1.7; x.stroke();
        x.shadowBlur = 0;
        x.strokeStyle = '#ffffff'; x.lineWidth = Math.max(.6, sg.w * .5); x.stroke();
      });
    });
    x.globalAlpha = 1; x.shadowBlur = 0;
  }
  /* timeline: left corner fires, right corner fires, then both together. [ms, left, right, dim, flash] */
  function storm(ms, onDone, arriving) {
    sizeStorm();
    var c = bolt.c;
    c.classList.add('is-on');
    var segs = crossfire(), bolts = [{ segs: segs[0], a: 0 }, { segs: segs[1], a: 0 }], t0 = performance.now();
    var keys = arriving
      ? [[0, .9, .9, .75, .6], [70, .3, .3, .6, .15], [120, .8, .8, .5, .45], [200, .2, .2, .3, .1], [320, 0, 0, 0, 0]]
      : [[0, 1, 0, .3, .5], [60, .2, 0, .35, .1], [100, .2, 1, .45, .55], [160, .9, .3, .5, .2], [230, 1, 1, .6, .85], [300, .4, .5, .62, .2], [360, 1, 1, .7, .9], [440, .9, .9, .8, .6]];
    function at(t) {
      for (var i = keys.length - 1; i >= 0; i--) if (t >= keys[i][0]) return keys[i];
      return keys[0];
    }
    (function frame(now) {
      var t = now - t0, k = at(t);
      bolts[0].a = k[1]; bolts[1].a = k[2];
      drawStorm(bolts, k[4] * (.7 + Math.random() * .3), k[3]);
      if (t < ms) requestAnimationFrame(frame);
      else { if (arriving) { c.classList.remove('is-on'); bolt.x.clearRect(0, 0, innerWidth, innerHeight); } if (onDone) onDone(); }
    })(t0);
  }
  function stormLinks() {
    if (window.gwStormOn) return;
    window.gwStormOn = 1;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.closest('.gw-yf')) return;
      var u;
      try { u = new URL(a.getAttribute('href'), location.href); } catch (er) { return; }
      if (u.origin !== location.origin || (u.protocol !== 'https:' && u.protocol !== 'http:')) return;
      if (u.pathname === location.pathname && u.search === location.search) return;
      e.preventDefault();
      if (bolt.busy) return;
      bolt.busy = true;
      try { sessionStorage.setItem('gwStorm', '1'); } catch (er) {}
      storm(500, function () { location.href = u.href; });
    });
    /* arriving on the next page: the last flash fades out */
    var arrived = false;
    try { arrived = sessionStorage.getItem('gwStorm') === '1'; sessionStorage.removeItem('gwStorm'); } catch (er) {}
    if (arrived) storm(340, null, true);
    /* arriving home after the page was slashed: the house fades up out of black */
    var slashed = false;
    try { slashed = sessionStorage.getItem('gwSlash') === '1'; sessionStorage.removeItem('gwSlash'); } catch (er) {}
    if (slashed) {
      var blk = document.createElement('div');
      blk.style.cssText = 'position:fixed;inset:0;z-index:2147482000;background:#000;pointer-events:none;';
      document.body.appendChild(blk);
      blk.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 650, easing: 'ease-out', fill: 'forwards' }).onfinish = function () { blk.remove(); };
    }
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted && bolt.c) { bolt.busy = false; bolt.c.classList.remove('is-on'); bolt.x.clearRect(0, 0, innerWidth, innerHeight); }
      if (ev.persisted) [].forEach.call(document.querySelectorAll('body > div[aria-hidden="true"][style*="2147482000"]'), function (n) { n.remove(); });
    });
  }

  /* whole words stay together: a blade quote never splits from its word, and a word with numbers in it (N3V4, G9, '23)
     never breaks between its letters and numbers */
  function isWordEl(n) { return n.nodeType === 1 && n.classList && (n.classList.contains('gw-num') || n.classList.contains('gwq') || n.classList.contains('gwq-glue')); }
  /* in a button laid out side by side, loose pieces would lose the spaces between them, so they are kept in one line of text */
  function flowFix(p) {
    if (!p || !p.dataset || p.dataset.gwFx) return;
    if (!/flex|grid/.test(getComputedStyle(p).display)) return;
    for (var c = p.firstChild; c; c = c.nextSibling) { if (c.nodeType === 1 && !isWordEl(c)) return; }
    var s = document.createElement('span');
    s.className = 'gwq-flow';
    while (p.firstChild) s.appendChild(p.firstChild);
    p.appendChild(s);
    p.dataset.gwFx = '1';
  }
  function glueWord(node) {
    var p = node.parentNode;
    if (!p || (p.classList && p.classList.contains('gwq-glue'))) return;
    var first = node, last = node, n, t, i;
    while ((n = first.previousSibling)) {
      if (isWordEl(n)) { first = n; continue; }
      if (n.nodeType === 3) {
        t = n.textContent;
        i = Math.max(t.lastIndexOf(' '), t.lastIndexOf('\n'), t.lastIndexOf('\t'), t.lastIndexOf(' '));
        if (i < 0) { first = n; continue; }
        if (i < t.length - 1) first = n.splitText(i + 1);
      }
      break;
    }
    while ((n = last.nextSibling)) {
      if (isWordEl(n)) { last = n; continue; }
      if (n.nodeType === 3) {
        t = n.textContent;
        i = t.search(/[\s ]/);
        if (i < 0) { last = n; continue; }
        if (i > 0) { n.splitText(i); last = n; }
      }
      break;
    }
    if (first === last) return;
    var w = document.createElement('span');
    w.className = 'gwq-glue';
    w.style.whiteSpace = 'nowrap';
    p.insertBefore(w, first);
    var c = first, nx;
    while (c) { nx = c.nextSibling; w.appendChild(c); if (c === last) break; c = nx; }
  }
  function glueQuotes() {
    var list = document.querySelectorAll('.gwq:not([data-gl]), .gw-num:not([data-gl])');
    [].forEach.call(list, function (q) { if (q.parentNode) flowFix(q.parentNode); });
    [].forEach.call(list, function (q) { q.setAttribute('data-gl', '1'); glueWord(q); });
  }
  var glueT = 0;
  function glueSoon() { if (glueT) return; glueT = setTimeout(function () { glueT = 0; glueQuotes(); }, 120); }
  if (window.MutationObserver) new MutationObserver(glueSoon).observe(document.documentElement, { childList: true, subtree: true });
  glueSoon();

  /* product titles stay on one line: if a name is too long for its column the letters shrink just enough to fit */
  function fitTitles() {
    [].forEach.call(document.querySelectorAll('.product__title > h1, .product__title > h2'), function (h) {
      h.style.fontSize = ''; h.style.whiteSpace = '';
      var base = parseFloat(getComputedStyle(h).fontSize), size = base;
      h.style.whiteSpace = 'nowrap';
      while (h.scrollWidth > h.clientWidth + 1 && size > base * .5) { size -= 1; h.style.fontSize = size + 'px'; }
      if (h.scrollWidth > h.clientWidth + 1) { h.style.fontSize = ''; h.style.whiteSpace = ''; }
    });
  }
  var fitT = 0;
  function fitSoon() { clearTimeout(fitT); fitT = setTimeout(fitTitles, 150); }
  window.addEventListener('resize', fitSoon);
  window.addEventListener('load', fitSoon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSoon);
  setTimeout(fitSoon, 600);

  function init() {
    stormLinks();
    syncSpin();
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var head = document.querySelector('.header__heading-link');
    if (head) setup(head, function () { return head.querySelector('.gw-head-chrome'); }, { link: true });
    var gb = document.querySelector('.gw-hero .gw-glintbox');
    if (gb) setup(gb, function () { return gb.querySelector('.gw-mark canvas:not(.gw-holo-layer):not(.gw-side)'); });
    if (head) solidify(head, function () { return head.querySelector('.gw-head-chrome'); });
    if (gb) solidify(gb.querySelector('.gw-mark'), function () { return gb.querySelector('.gw-mark canvas:not(.gw-holo-layer):not(.gw-side)'); });
    if (head) sideWall(head, head, function () { return head.querySelector('.gw-head-chrome'); });
    if (gb) sideWall(gb.querySelector('.gw-mark'), gb, function () { return gb.querySelector('.gw-mark canvas:not(.gw-holo-layer):not(.gw-side)'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
